<template>
  <Modal
    v-model="_value"
    width="500"
    title="锐明设置IP"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Tabs value="Checkbox" type="card" >
      <TabPane label="选择通道" name="Checkbox">
        <Form ref="setDriverParamsRef" v-model="setDriverParams" :label-width="90">
          <FormItem prop="possword" label="密码">
            <Button type="primary" @click="possworsOne" style="margin-right: 5px;">密码1</Button>
            <Button type="primary" @click="posswordTwo">密码2</Button>
            <Input v-model="setDriverParams.possword" type="password" password placeholder="请输入密码">
            </Input>
          </FormItem>
<!--          <FormItem prop="CC" label="客户代码">-->
<!--            <Input v-model="setDriverParams.CC" placeholder="请输入客户代码">-->
<!--            </Input>-->
<!--          </FormItem>-->
<!--          <FormItem prop="NBB" label="协议版本">-->
<!--            &lt;!&ndash;        <Input v-model="setDriverParams.NBB" placeholder="请输入协议版本">&ndash;&gt;-->
<!--            &lt;!&ndash;        </Input>&ndash;&gt;-->

<!--            <Select v-model="setDriverParams.NBB">-->
<!--              <Option v-for="item in NBBOptions" :value="item.value" :key="item.value">{{item.label}}</Option>-->
<!--            </Select>-->

<!--          </FormItem>-->
          <!--      <FormItem prop="driverLicenseNum" label="从业资格证号">-->
          <!--      <FormItem prop="driverLicenseNum" label="司机卡号">-->
          <!--        <Input v-model="setDriverParams.qualificationCode" placeholder="请输入司机卡号">-->
          <!--        </Input>-->
          <!--      </FormItem>-->
          <!--      <FormItem prop="driverLicenseNum" label="发证机构名称">-->
          <!--        <Input v-model="setDriverParams.organizationNames" placeholder="请输入发证机构名称">-->
          <!--        </Input>-->
          <!--      </FormItem>-->
          <!--      <FormItem prop="driverLicenseNum" label="证件有效期">-->
          <!--        <Input v-model="setDriverParams.indate" placeholder="请输入证件有效期">-->
          <!--        </Input>-->
          <!--      </FormItem>-->

          <FormItem prop="NBB" label="通道">
            <CheckboxGroup v-model="setDriverParams.Checkbox">
              <Checkbox label="1"></Checkbox>
              <Checkbox label="2" disabled></Checkbox>
              <Checkbox label="3" disabled></Checkbox>
              <Checkbox label="4"></Checkbox>
              <Checkbox label="5"></Checkbox>
              <Checkbox label="6"></Checkbox>
            </CheckboxGroup>
          </FormItem>

          <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
          <Button type="primary" @click="onSendDriverCardParams">发送</Button>
        </Form>
      </TabPane>

      <template v-for="(item, index) in setDriverParams.Checkbox">

      <TabPane :index="index" v-if="item == 1" label="通道1" name="access1">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.SP[0]" :label-width="100">


          <FormItem>
            <Checkbox v-model="setDriverParams.SP[0].EN">通道使能</Checkbox>
          </FormItem>

          <FormItem prop="CP" label="通道协议">
            <Select v-model="setDriverParams.SP[0].CP">
              <Option v-for="item in CPOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

          <FormItem prop="NWT" label="网路类型">
            <Select v-model="setDriverParams.SP[0].NWT">
              <Option v-for="item in NWTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

                    <FormItem prop="CS" label="通道IP">
                      <Input v-model="setDriverParams.SP[0].CS" placeholder="通道IP">
                      </Input>
                    </FormItem>
                    <FormItem prop="CPORT" label="通道IP端口">
                      <Input v-model="setDriverParams.SP[0].CPORT" placeholder="通道IP端口">
                      </Input>
                    </FormItem>
          <FormItem prop="CUPORT" label="通道UDP">
            <Input v-model="setDriverParams.SP[0].CUPORT" placeholder="通道UDP">
            </Input>
          </FormItem>

          <FormItem prop="MS" label="通道备份IP">
            <Input v-model="setDriverParams.SP[0].MS" placeholder="通道备份IP">
            </Input>
          </FormItem>
          <FormItem prop="MPORT" label="通道备份IP端口">
            <Input v-model="setDriverParams.SP[0].MPORT" placeholder="通道备份IP端口">
            </Input>
          </FormItem>
          <FormItem prop="MUPORT" label="通道备份UDP">
            <Input v-model="setDriverParams.SP[0].MUPORT" placeholder="通道备份UDP">
            </Input>
          </FormItem>

        </Form>
      </TabPane>
      <TabPane :index="index" v-if="item == 2"  label="通道2" name="access2">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.SP[1]" :label-width="100">

          <FormItem>
            <Checkbox v-model="setDriverParams.SP[1].EN">通道使能</Checkbox>
          </FormItem>

          <FormItem prop="CP" label="通道协议">
            <Select v-model="setDriverParams.SP[1].CP">
              <Option v-for="item in CPOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

          <FormItem prop="NWT" label="网路类型">
            <Select v-model="setDriverParams.SP[1].NWT">
              <Option v-for="item in NWTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

          <FormItem prop="CS" label="通道IP">
            <Input v-model="setDriverParams.SP[1].CS" placeholder="通道IP">
            </Input>
          </FormItem>
          <FormItem prop="CPORT" label="通道IP端口">
            <Input v-model="setDriverParams.SP[1].CPORT" placeholder="通道IP端口">
            </Input>
          </FormItem>
          <FormItem prop="CUPORT" label="通道UDP">
            <Input v-model="setDriverParams.SP[1].CUPORT" placeholder="通道UDP">
            </Input>
          </FormItem>

          <FormItem prop="MS" label="通道备份IP">
            <Input v-model="setDriverParams.SP[1].MS" placeholder="通道备份IP">
            </Input>
          </FormItem>
          <FormItem prop="MPORT" label="通道备份IP端口">
            <Input v-model="setDriverParams.SP[1].MPORT" placeholder="通道备份IP端口">
            </Input>
          </FormItem>
          <FormItem prop="MUPORT" label="通道备份UDP">
            <Input v-model="setDriverParams.SP[1].MUPORT" placeholder="通道备份UDP">
            </Input>
          </FormItem>

        </Form>
      </TabPane>
      <TabPane :index="index" v-if="item == 3"  label="通道3" name="access3">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.SP[2]" :label-width="100">

          <FormItem>
            <Checkbox v-model="setDriverParams.SP[2].EN">通道使能</Checkbox>
          </FormItem>

          <FormItem prop="CP" label="通道协议">
            <Select v-model="setDriverParams.SP[2].CP">
              <Option v-for="item in CPOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

          <FormItem prop="NWT" label="网路类型">
            <Select v-model="setDriverParams.SP[2].NWT">
              <Option v-for="item in NWTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

          <FormItem prop="CS" label="通道IP">
            <Input v-model="setDriverParams.SP[2].CS" placeholder="通道IP">
            </Input>
          </FormItem>
          <FormItem prop="CPORT" label="通道IP端口">
            <Input v-model="setDriverParams.SP[2].CPORT" placeholder="通道IP端口">
            </Input>
          </FormItem>
          <FormItem prop="CUPORT" label="通道UDP">
            <Input v-model="setDriverParams.SP[2].CUPORT" placeholder="通道UDP">
            </Input>
          </FormItem>

          <FormItem prop="MS" label="通道备份IP">
            <Input v-model="setDriverParams.SP[2].MS" placeholder="通道备份IP">
            </Input>
          </FormItem>
          <FormItem prop="MPORT" label="通道备份IP端口">
            <Input v-model="setDriverParams.SP[2].MPORT" placeholder="通道备份IP端口">
            </Input>
          </FormItem>
          <FormItem prop="MUPORT" label="通道备份UDP">
            <Input v-model="setDriverParams.SP[2].MUPORT" placeholder="通道备份UDP">
            </Input>
          </FormItem>

        </Form>
      </TabPane>
      <TabPane :index="index" v-if="item == 4"  label="通道4" name="access4">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.SP[3]" :label-width="100">

          <FormItem>
            <Checkbox v-model="setDriverParams.SP[3].EN">通道使能</Checkbox>
          </FormItem>

          <FormItem prop="CP" label="通道协议">
            <Select v-model="setDriverParams.SP[3].CP">
              <Option v-for="item in CPOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

          <FormItem prop="NWT" label="网路类型">
            <Select v-model="setDriverParams.SP[3].NWT">
              <Option v-for="item in NWTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

          <FormItem prop="CS" label="通道IP">
            <Input v-model="setDriverParams.SP[3].CS" placeholder="通道IP">
            </Input>
          </FormItem>
          <FormItem prop="CPORT" label="通道IP端口">
            <Input v-model="setDriverParams.SP[3].CPORT" placeholder="通道IP端口">
            </Input>
          </FormItem>
          <FormItem prop="CUPORT" label="通道UDP">
            <Input v-model="setDriverParams.SP[3].CUPORT" placeholder="通道UDP">
            </Input>
          </FormItem>

          <FormItem prop="MS" label="通道备份IP">
            <Input v-model="setDriverParams.SP[3].MS" placeholder="通道备份IP">
            </Input>
          </FormItem>
          <FormItem prop="MPORT" label="通道备份IP端口">
            <Input v-model="setDriverParams.SP[3].MPORT" placeholder="通道备份IP端口">
            </Input>
          </FormItem>
          <FormItem prop="MUPORT" label="通道备份UDP">
            <Input v-model="setDriverParams.SP[3].MUPORT" placeholder="通道备份UDP">
            </Input>
          </FormItem>

        </Form>
      </TabPane>
      <TabPane :index="index" v-if="item == 5"  label="通道5" name="access5">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.SP[4]" :label-width="100">

          <FormItem>
            <Checkbox v-model="setDriverParams.SP[4].EN">通道使能</Checkbox>
          </FormItem>

          <FormItem prop="CP" label="通道协议">
            <Select v-model="setDriverParams.SP[4].CP">
              <Option v-for="item in CPOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

          <FormItem prop="NWT" label="网路类型">
            <Select v-model="setDriverParams.SP[4].NWT">
              <Option v-for="item in NWTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

          <FormItem prop="CS" label="通道IP">
            <Input v-model="setDriverParams.SP[4].CS" placeholder="通道IP">
            </Input>
          </FormItem>
          <FormItem prop="CPORT" label="通道IP端口">
            <Input v-model="setDriverParams.SP[4].CPORT" placeholder="通道IP端口">
            </Input>
          </FormItem>
          <FormItem prop="CUPORT" label="通道UDP">
            <Input v-model="setDriverParams.SP[4].CUPORT" placeholder="通道UDP">
            </Input>
          </FormItem>

          <FormItem prop="MS" label="通道备份IP">
            <Input v-model="setDriverParams.SP[4].MS" placeholder="通道备份IP">
            </Input>
          </FormItem>
          <FormItem prop="MPORT" label="通道备份IP端口">
            <Input v-model="setDriverParams.SP[4].MPORT" placeholder="通道备份IP端口">
            </Input>
          </FormItem>
          <FormItem prop="MUPORT" label="通道备份UDP">
            <Input v-model="setDriverParams.SP[4].MUPORT" placeholder="通道备份UDP">
            </Input>
          </FormItem>

        </Form>
      </TabPane>
      <TabPane :index="index" v-if="item == 6"  label="通道6" name="access6">
        <Form ref="setDriverParamsRef" v-model="setDriverParams.SP[5]" :label-width="100">

          <FormItem>
            <Checkbox v-model="setDriverParams.SP[5].EN">通道使能</Checkbox>
          </FormItem>

          <FormItem prop="CP" label="通道协议">
            <Select v-model="setDriverParams.SP[5].CP">
              <Option v-for="item in CPOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

          <FormItem prop="NWT" label="网路类型">
            <Select v-model="setDriverParams.SP[5].NWT">
              <Option v-for="item in NWTOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
            </Select>
          </FormItem>

          <FormItem prop="CS" label="通道IP">
            <Input v-model="setDriverParams.SP[5].CS" placeholder="通道IP">
            </Input>
          </FormItem>
          <FormItem prop="CPORT" label="通道IP端口">
            <Input v-model="setDriverParams.SP[5].CPORT" placeholder="通道IP端口">
            </Input>
          </FormItem>
          <FormItem prop="CUPORT" label="通道UDP">
            <Input v-model="setDriverParams.SP[5].CUPORT" placeholder="通道UDP">
            </Input>
          </FormItem>

          <FormItem prop="MS" label="通道备份IP">
            <Input v-model="setDriverParams.SP[5].MS" placeholder="通道备份IP">
            </Input>
          </FormItem>
          <FormItem prop="MPORT" label="通道备份IP端口">
            <Input v-model="setDriverParams.SP[5].MPORT" placeholder="通道备份IP端口">
            </Input>
          </FormItem>
          <FormItem prop="MUPORT" label="通道备份UDP">
            <Input v-model="setDriverParams.SP[5].MUPORT" placeholder="通道备份UDP">
            </Input>
          </FormItem>

        </Form>
      </TabPane>

      </template>

    </Tabs>
  </Modal>
</template>

<script>

  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import store from '@/store'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

  import MaintainOrderAddMaintainDeviceRecordModal from '@/view/om/components/maintain-order-add-maintain-device-record-modal'

  export default {
    name: 'rmsetdriveripmodal',
    components: {

    },
    props: {
      initValue: null,
      terminalNumValue: null,
      value: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        setDriverParams: {
          id: null,
          possword: 'admin',
          qualificationCode: null,
          organizationNames: null,
          indate: null,
          Checkbox:[],
          M:'001100000110',
          SP:[
            {CP:'',NWT:'',CS:'',CPORT:'',CUPORT:'',MS:'',MPORT:'',MUPORT:'',EN:'1'},
            {CP:'',NWT:'',CS:'',CPORT:'',CUPORT:'',MS:'',MPORT:'',MUPORT:'',EN:'1'},
            {CP:'',NWT:'',CS:'',CPORT:'',CUPORT:'',MS:'',MPORT:'',MUPORT:'',EN:'1'},
            {CP:'',NWT:'',CS:'',CPORT:'',CUPORT:'',MS:'',MPORT:'',MUPORT:'',EN:'1'},
            {CP:'',NWT:'',CS:'',CPORT:'',CUPORT:'',MS:'',MPORT:'',MUPORT:'',EN:'1'},
            {CP:'2',NWT:'2',CS:'yt.dlysjg.td.gd.gov.cn',CPORT:'',CUPORT:'',MS:'',MPORT:'',MUPORT:'',EN:true},
          ]
        },

        JSON:['null','null','null','null','null','null'],
        M:'',

        CPOptions: [
          {label: 'N9M', value: '0'},
          {label: '808', value: '2'},
          {label: '运维', value: '3'},
          {label: 'IC卡', value: '4'},
        ],

        NWTOptions: [
          {label: '有线网络', value: '0'},
          {label: 'WIFI', value: '1'},
          {label: '通讯模块1', value: '2'},
          {label: '通讯模块2', value: '3'},
          {label: '自适应', value: '4'},
        ],

      }
    },
    methods: {
      ...mapActions([
        'VehicleInfoServ_SearchByName'
      ]),
      visibleChange (val) {
        if (val) {
          this.setDriverParams.id = this._initValue
          this.setDriverParams.qualificationCode = null
          this.setDriverParams.organizationNames = null
          this.setDriverParams.indate = null
          this.possworsOne()
        }
      },
      onCleanDriverCardParams () {
        this.setDriverParams.possword = 'admin'
        this.setDriverParams.qualificationCode = null
        this.setDriverParams.organizationNames = null
        this.setDriverParams.indate = null
      },

      changeStr(str,index,changeStr){
        return str.substr(0, index) + changeStr+ str.substr(index + changeStr.length);
      },
      onSendDriverCardParams () {
        // if (this.setDriverParams.CC == null){
        //   this.$Message.error("请输入客户代码")
        // }
        // if (this.setDriverParams.NBB == null){
        //   this.$Message.error("请选择协议版本")
        // }
        // if (this.setDriverParams.NBB != null) {
        //   this.setDriverParams.qualificationCode = this.setDriverParams.NBB
        // }

        console.log(this.setDriverParams)
        for (let i = 0; i < this.setDriverParams.Checkbox.length; i++) {
        console.log(this.JSON)
        console.log(this.setDriverParams.Checkbox[i])
        console.log(this.setDriverParams.SP[this.setDriverParams.Checkbox[i]-1])
        console.log(JSON.stringify(this.JSON[this.setDriverParams.Checkbox[i]-1]))
          this.JSON[this.setDriverParams.Checkbox[i]-1] = JSON.stringify(this.setDriverParams.SP[this.setDriverParams.Checkbox[i]-1])
        console.log(this.JSON[this.setDriverParams.Checkbox[i]-1])

          if (this.setDriverParams.SP[this.setDriverParams.Checkbox[i]].EN) {
            this.setDriverParams.SP[this.setDriverParams.Checkbox[i]].EN = 1
          }else {
            this.setDriverParams.SP[this.setDriverParams.Checkbox[i]].EN = 0
          }

          console.log(i)
          console.log(this.setDriverParams.M.length-i)

          this.setDriverParams.M = this.changeStr(this.setDriverParams.M,this.setDriverParams.M.length-(this.setDriverParams.Checkbox[i]),'1')
        }

        console.log(this.setDriverParams.M)
        this.M = parseInt(this.setDriverParams.M,2)

        //99admin,admin,JSON,{"PSI":{"SP":[null,null,null,{"CC":"54","GPS":{"NBB":"0"}},null,null]}}!
        console.log('99admin,' + this.setDriverParams.possword + ',JSON,{"MCMS":{"H":"0","M":' + this.M + ',"SP":[' + this.JSON + ']}}!')
        let content = '99admin,' + this.setDriverParams.possword + ',JSON,{"MCMS":{"H":"0","M":' + this.M + ',"SP":[' + this.JSON + ']}}!'
        store.dispatch('NetCommandServ_SendCommand', {
          params: { id: this._initValue, content:content, urgent: false }
        }).then(() => {
          this.$Message.success('发送成功')
          this.JSON = ['null','null','null','null','null','null']
        }).catch(err => {
          this.$Message.error(err)
          this.JSON = ['null','null','null','null','null','null']
        })
      },
      possworsOne(){
        this.setDriverParams.possword = 'admin'
      },
      posswordTwo(){
        this.setDriverParams.possword = 'JC336699'
      },
    },
    computed: {
      _value: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get () {
          return this.initValue
        },
        set (val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _terminalNumValue: {
        get () {
          return this.terminalNumValue
        },
        set (val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted () {
      this.$nextTick(() => {

      })
    }
  }
</script>
